import { observable, action, computed, makeObservable } from 'mobx';

import { EntryData, EntryTypeFieldName, EntryStatus } from 'chaika-frontend-types/frontend-cms';

import { EntryFields, IField } from '@store/models/EntryFields';

export class EntryVersion {
    @observable public id: string;
    @observable public updateTime: string;
    @observable public author: string;
    @observable public status: EntryStatus;
    @observable public fields: EntryFields = new EntryFields();

    public constructor({
        id,
        updateTime,
        fields,
        author,
        status,
    }: Pick<EntryData, 'id' | 'updateTime' | 'author' | 'fields' | 'status'>) {
        makeObservable(this);

        this.id = id;
        this.updateTime = updateTime;
        this.status = status;
        this.author = author;

        this.fields = new EntryFields(fields);
    }

    @computed
    public get isSignedVersion(): boolean {
        return this.status === EntryStatus.Signed;
    }

    @action
    public reset(): void {
        this.id = '';
        this.updateTime = '';

        this.fields.reset();
    }

    public getField(name: string): IField {
        return this.fields.get(name);
    }

    public getFieldValue<T>(name: string): T {
        return this.fields.getValue(name);
    }

    @action
    public setFieldValue(name: EntryTypeFieldName, value: any): void {
        this.fields.set(name, value);
    }
}
